import { render } from "./ServiceTypeBadge.vue?vue&type=template&id=41b561ec&ts=true"
import script from "./ServiceTypeBadge.vue?vue&type=script&lang=ts"
export * from "./ServiceTypeBadge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QTooltip});
